<script>
export default {
    name: 'ServicePlanFeatureCalendahActiveCalendar',
};
</script>

<script setup>
import ServicePlanFeatureElementsArray
    from '@/components/payments/components/service-plan/components/features/components/elements/array.vue';
import { CALENDAR_SHARE_SCOPE_LABEL } from '@/modules/calendah/constants.ts';

defineProps({
    feature: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <service-plan-feature-elements-array
        class="inline-block max-w-60"
        :feature="feature"
        :map="CALENDAR_SHARE_SCOPE_LABEL"
        unit="calendars"
    />
</template>
